import { render, staticRenderFns } from "./pojecthomepage.vue?vue&type=template&id=f8b75eb6&scoped=true&"
import script from "./pojecthomepage.js?vue&type=script&lang=js&"
export * from "./pojecthomepage.js?vue&type=script&lang=js&"
import style0 from "./pojecthomepage.vue?vue&type=style&index=0&id=f8b75eb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b75eb6",
  null
  
)

export default component.exports